import { FarcanaDailyBonusRowProps } from '../types'
import { DailyBonusWrapper } from '../dailyBonus'
import { DailyBonusSeparator } from '@/shared/ui/dailyBonusSeparator'
import { useStyles } from './styles'
import { Glow } from '@/shared/ui/glow'
import { useUnit } from 'effector-react'
import { $userToken } from '@/entities/user'
import { claimFarcanaBonusFx, getFarcanaBonusInfoFx } from '@/entities/dailyBonus/model/effects'
import { moneyRain } from '@/shared/util/moneyRain'
import { useState } from 'react'

export const FarcanaDailyBonusRow = (props: FarcanaDailyBonusRowProps) => {
  const { currentDay, canClaim } = props
  const amount = currentDay === 7 ? 69 : props.reward
  const { classes } = useStyles()
  const userToken = useUnit($userToken)

  const [isLoading, setIsLoading] = useState(false)

  const handleClaimDailyBonus = () => {
    if (!canClaim) {
      return
    }
    try {
      setIsLoading(true)
      moneyRain()
      claimFarcanaBonusFx({ token: userToken!, day: currentDay })
    } catch (e) {
      console.error(e)
    } finally {
      setTimeout(() => {
        getFarcanaBonusInfoFx(userToken!)
      }, 1000)

      setTimeout(() => {
        setIsLoading(false)
      }, 1300)
    }
  }

  return (
    <div
      className={classes.root}
      data-canclaim={canClaim}
    >
      <DailyBonusSeparator
        day={currentDay}
        position="relative"
        width={'fit-content'}
      />
      <DailyBonusWrapper
        imgStyles={{ width: '70%', alignSelf: 'center' }}
        amount={amount}
        background={'#151618'}
        minWidth={158}
        height={96}
        boxShadow="0px 1px 0px 0px #393C40, 0px 1px 0px 0px #000 inset"
        protoStyles={{ width: 'fit-content' }}
        isShowingLocker={!canClaim}
        isDisabled={false}
        rewardKind={props.rewardKind}
        isClaimed={props.isClaimed}
        isLoading={isLoading}
        onClick={() => handleClaimDailyBonus()}
      />
      {canClaim && (
        <Glow
          left={'60%'}
          width={120}
          height={60}
          filter="blur(45px)"
          background={'rgb(39, 108, 255)'}
        />
      )}
    </div>
  )
}
